import React, { useContext, useEffect, useState } from "react";
import { Accordion } from "react-bootstrap";
import SearchTable from "../../../components/search-table/SearchTable";
import SearchPromotionsTable from "../../../components/search-promotions-table/SearchPromotionsTable";
import { useLocation } from "react-router-dom";
import { StoreContext } from "../../../store/StoreContext";
import { makeTree } from "../../../helpers";
import { IconCheveron, IconCircle, IconPrinter } from "../../../icons/Icon";
import { COLOR_TEXT } from "../../../constants/colors";
import "../../../assets/styles/sidebar.scss";
import { getSearch } from "../../../api/search";
import { useRef } from "react";

const defaultColor = "#32373E";

// Tree menu item component for Seeker view
const SeekerTreeItem = ({ item, depth = 0, onItemSelect, selectedItemId }) => {
  const [expand, setExpand] = useState(false);
  const isChildren = item?.children?.length > 0;
  const isActive = selectedItemId === item.id;
  const color = isActive ? COLOR_TEXT : defaultColor;

  const handleClick = () => {
    if (isChildren) {
      setExpand((val) => !val);
    } else {
      // Leaf item - select it to show SearchTableSkirts
      onItemSelect(item);
    }
  };

  return (
    <div className="menu-item">
      <div
        className={`menu-item-main py-2 ${isActive ? "active" : ""}`}
        onClick={handleClick}
        style={{ paddingLeft: `${depth * 20 + 12}px` }}
      >
        <div className="icon">
          {depth === 0 ? (
            <IconPrinter color={color} />
          ) : (
            <IconCircle color="#748A9D" />
          )}
        </div>
        <span className="text text-truncate ps-3">{item.title}</span>
        {isChildren && (
          <span className="expand-button">
            <IconCheveron color="#33383F" />
          </span>
        )}
      </div>
      {isChildren && (
        <div className={`menu-item-child ${expand ? "expand" : ""}`}>
          {item.children.map((child) => (
            <SeekerTreeItem
              key={child.id}
              item={child}
              depth={depth + 1}
              onItemSelect={onItemSelect}
              selectedItemId={selectedItemId}
            />
          ))}
        </div>
      )}
    </div>
  );
};

const Seeker = () => {
  const location = useLocation();
  const filter = location.state?.filter;
  const {
    skirts,
    searchResult,
    setSearchResult,
    searching,
    setSearching,
    serach,
    setSearch,
  } = useContext(StoreContext);
  const hasAutoSearchedRef = useRef(false);
  const [treeData, setTreeData] = useState([]);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [showFaldonesExpanded, setShowFaldonesExpanded] = useState(
    filter === "skirt" || !filter
  );

  useEffect(() => {
    if (skirts.length > 0) {
      let _skirts = skirts.map((skirt) => ({
        ...skirt,
        parent: skirt?.parent || 0,
      }));
      _skirts = makeTree(_skirts, 0);
      setTreeData(_skirts);
    }
  }, [skirts]);

  const handleItemSelect = (item) => {
    setSelectedItemId(item.id);
  };

  const handleFaldonesClick = () => {
    setShowFaldonesExpanded((val) => !val);
    if (selectedItemId) {
      setSelectedItemId(null);
    }
  };

  // Auto-trigger search when landing directly on Seeker (no topbar action)
  useEffect(() => {
    if (hasAutoSearchedRef.current) return;
    hasAutoSearchedRef.current = true;
    const doSearch = async () => {
      try {
        // Avoid duplicate fetch if already searching or we already have results
        if (searching || (searchResult && searchResult.length > 0)) return;
        setSearching(true);
        const searchValue = serach || "";
        setSearch(searchValue);
        const result = await getSearch(searchValue);
        const data = result?.data?.O_ARTICULOS || [];
        const safeData = Array.isArray(data) ? data : [];
        setSearchResult(safeData);
      } catch (err) {
        setSearchResult([]);
      } finally {
        setSearching(false);
      }
    };
    doSearch();
  }, []);

  return (
    <>
      <Accordion
        alwaysOpen
        defaultActiveKey={
          filter === "skirt"
            ? ['1']
            : filter === "promotions"
            ? ['0']
            : ['0', '1']
        }
      >
        <Accordion.Item eventKey="0" style={{marginBottom: '15px'}}>
          <Accordion.Header style={{backgroundColor: '#ffffff', color: '#000'}}>Productos en Promociones</Accordion.Header>
          <Accordion.Body>
            <SearchTable />
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="1" style={{marginBottom: '15px'}}>
          <Accordion.Header style={{backgroundColor: '#ffffff', color: '#000'}}>Faldones en Promociones</Accordion.Header>
          <Accordion.Body>
            <SearchPromotionsTable minimalMode={true} />
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </>
  );
};

export default Seeker;
